// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3MvD-","addWidgetButton":"Header_addWidgetButton__zj4Z8","dashboardTabs":"Header_dashboardTabs__1eFvd","active":"Header_active__1Pp_s"};